export default __webpack_public_path__ + "static/media/icon2.34b756a5.png";